module.exports = "https://coursera_assets.s3.amazonaws.com/images/7b2437556cbdd0ff8988e4503ce58c51.png";